import axios from 'axios';

// Point to the new Concert Event Management API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Event APIs - Updated for new Concert API
export const eventAPI = {
  getAll: () => api.get('/events'),
  getById: (id) => api.get(`/events/${id}`),
  getAvailability: (id) => api.get(`/events/${id}/availability`),
  getBookings: (id) => api.get(`/events/${id}/bookings`),
};

// Booking APIs - New webhook-based endpoints
export const bookingAPI = {
  create: (data) => api.post('/webhooks/booking/create', {
    webhook_id: `web-${Date.now()}`,
    timestamp: new Date().toISOString(),
    ...data
  }),
  cancel: (bookingId, customerId, reason) => api.post('/webhooks/booking/cancel', {
    webhook_id: `web-${Date.now()}`,
    timestamp: new Date().toISOString(),
    booking_id: bookingId,
    customer_id: customerId,
    cancellation_reason: reason
  }),
  upgrade: (bookingId, customerId, newTicketType) => api.post('/webhooks/booking/upgrade', {
    webhook_id: `web-${Date.now()}`,
    timestamp: new Date().toISOString(),
    booking_id: bookingId,
    customer_id: customerId,
    new_ticket_type: newTicketType
  }),
  getStatus: (bookingId, customerId) => 
    api.get(`/webhooks/booking/${bookingId}/status`, { params: { customer_id: customerId } }),
};

// Availability check API
export const availabilityAPI = {
  check: (eventId, ticketType, quantity) => api.post('/webhooks/availability/check', {
    webhook_id: `web-${Date.now()}`,
    timestamp: new Date().toISOString(),
    event_id: eventId,
    ticket_type: ticketType,
    quantity: quantity
  }),
};

// Purchase APIs - Keep for now, will integrate with new API later
export const purchaseAPI = {
  createSession: (data) => api.post('/purchases/create-session', data),
  lookupByPhone: (phone) => api.get(`/purchases/lookup/${phone}`),
  upgrade: (data) => api.post('/purchases/upgrade', data),
};

// Checkout APIs - Keep for now, will integrate with new API later
export const checkoutAPI = {
  getSession: (token) => api.get(`/checkout/${token}`),
  complete: (token, data) => api.post(`/checkout/${token}/complete`, data),
  cancel: (token) => api.post(`/checkout/${token}/cancel`),
};

// Admin APIs - Removed as not available in new API
export const adminAPI = {
  getDashboard: () => Promise.resolve({ data: { message: 'Admin features not available in new API' } }),
  getAllEvents: () => eventAPI.getAll(),
  getAllPurchases: () => Promise.resolve({ data: [] }),
  getEventPurchases: (eventId) => eventAPI.getBookings(eventId),
  createTicketType: () => Promise.resolve({ data: { message: 'Not supported' } }),
  updateTicketType: () => Promise.resolve({ data: { message: 'Not supported' } }),
  deleteEvent: () => Promise.resolve({ data: { message: 'Not supported' } }),
  cleanupSessions: () => Promise.resolve({ data: { message: 'Not supported' } }),
};

export default api;